<template>
  <section id="tables">
    <div class="demo">
      <h5>Small table</h5>
      <table class="table table-borderless table-striped">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">First</th>
            <th scope="col">Last</th>
            <th scope="col">Handle</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">1</th>
            <td data-title="Column 1">Mark</td>
            <td data-title="Column 2">Otto</td>
            <td data-title="Column 3">@mdo</td>
          </tr>
          <tr>
            <th scope="row">2</th>
            <td data-title="Column 1">Jacob</td>
            <td data-title="Column 2">Thornton</td>
            <td data-title="Column 3">@fat</td>
          </tr>
          <tr>
            <th scope="row">3</th>
            <td data-title="Column 1">Larry</td>
            <td data-title="Column 2">Bird</td>
            <td data-title="Column 3">@twitter</td>
          </tr>
        </tbody>
      </table>

      <h5 class="mt-5">Page level table</h5>
      <div class="table-responsive">
        <table class="table table-striped table-hover">
            <caption class="sr-only">List of jobs</caption>
            <thead class="thead-dark thead-sortable">
              <tr>
                <th scope="col"><a href="#" aria-label="sorting by Job ID">Job ID</a></th>
                <th scope="col"><a href="#" aria-label="sorting by Job Title">Job Title</a></th>
                <th scope="col"><a href="#" aria-label="sorting by Recruiter">Recruiter</a>
                </th>
                <th scope="col"><a href="#" aria-label="sorting by Status">Status</a>
                </th>
                <th scope="col" class="sorted"><a href="#" class="sort-up" aria-label="sorting by Opening date">Opening date </a></th>
                <th scope="col"><a href="#" aria-label="sorting by Closing date">Closing date </a></th>
                <th scope="col" class="disabled"><span class="sr-only">Action</span></th>
              </tr>
            </thead>
            <tbody>
              <tr class="clickable">
                <th scope="row"><a href="job-card">Senior Developer</a></th>
                <td data-title="Job ID">
                  53302044          </td>
                <td data-title="Recruiter">Peter Smith</td>
                <td data-title="Status">
                  Offer Made
                </td>
                <td data-title="Opening date">Jul 14, 2017</td>
                <td data-title="Closing date">Jan 23, 2018</td>
                <td scope="row" class="text-center">
                  <a class="d-none d-md-block" aria-label="View application" href="job-card"> View <i aria-hidden="true" class="gel-icon-angle-right gel-icon-sm"></i></a>
                  <a class="btn btn-primary btn-block d-md-none" href="job-card"> View </a>
                </td>
              </tr>
              <tr class="clickable">
                <th scope="row"><a href="job-card">Retail Customer Service Officer </a></th>
                <td data-title="Job ID">
                  53302043          </td>
                <td data-title="Recruiter"> Arnold Schwarzenegger </td>
                <td data-title="Status">
                  Approved to advertise
                </td>
                <td data-title="Opening date">Jul 14, 2017</td>
                <td data-title="Closing date">Jan 23, 2018</td>
                <td scope="row" class="text-center">
                  <a class="d-none d-md-block text-nowrap" aria-label="View application" href="job-card"> View <i aria-hidden="true" class="gel-icon-angle-right gel-icon-sm"></i></a>
                  <a class="btn btn-primary btn-block d-md-none" href="job-card"> View </a>
                </td>
              </tr>
                    <tr class="clickable">
                <th scope="row"><a href="job-card">International Consultant on Early Childhood Development</a></th>
                <td data-title="Job ID">
                  53302046          </td>
                <td data-title="Recruiter">Peter Smith</td>
                <td data-title="Status">
                  Offer Made
                </td>
                <td data-title="Opening date">Jul 14, 2017</td>
                <td data-title="Closing date">Jan 23, 2018</td>
                <td scope="row" class="text-center">
                  <a class="d-none d-md-block" aria-label="View application" href="job-card"> View <i aria-hidden="true" class="gel-icon-angle-right gel-icon-sm"></i></a>
                  <a class="btn btn-primary btn-block d-md-none" href="job-card"> View </a>
                </td>
              </tr>
              <tr class="clickable">
                <th scope="row"><a href="job-card">Retail Customer Service Officer </a></th>
                <td data-title="Job ID">
                  53302044          </td>
                <td data-title="Recruiter"> Arnold Schwarzenegger </td>
                <td data-title="Status">
                  Approved to advertise
                </td>
                <td data-title="Opening date">Jul 14, 2017</td>
                <td data-title="Closing date">Jan 23, 2018</td>
                <td scope="row" class="text-center">
                  <a class="d-none d-md-block text-nowrap" aria-label="View application" href="job-card"> View <i aria-hidden="true" class="gel-icon-angle-right gel-icon-sm"></i></a>
                  <a class="btn btn-primary btn-block d-md-none" href="job-card"> View </a>
                </td>
              </tr>
            </tbody>
          </table>
      </div>
    </div> 
    <section class="md" v-html="mdfile"></section> 
  </section> 
</template>

<script>
import mdfile from "@/docs/components/tables.md";
export default {
  name: "tables",
  beforeCreate: function () {
    this.$emit("update-title", this.$root.yamlData.components.tables.name);
    this.$emit("update-tagline", this.$root.yamlData.components.tables.description);
  },
  data() {
    return {
      mdfile
    };
  }
};
</script>
